export default {
  code: 'code',
  consumerCode: 'consumerCode',
  market: 'market',
  name: 'name',
}
